module.exports = __webpack_public_path__ + "img/logoA2.340963ce.png";